import { useConversationInviteInfo } from '@/features/chats/model/conversation/selectors';
import { usePresenceData, useTypingData } from '@/features/chats/model/lastSeen/reducer';
import GroupParticipants from '@/features/chats/ui/Conversation/GroupParticipants';
import { isGroupChat } from '@/features/chats/utils';
import { Username } from '@/features/users';
import { useLanguage } from '@/localization/useLanguage';
import { getUserIdFromJid } from '@/shared/utils';
import PropTypes from 'prop-types';
import { useLastSeen } from '../../viewmodel/useLastSeen';

const TypingStatus = ({ typingStatusData, t }) => {
   if (typingStatusData?.groupId) {
      return (
         <span className="chat-message-text">
            <Username userId={typingStatusData.fromUserId} /> {t('chat.TYPING')}...
         </span>
      );
   }
   if (typingStatusData?.fromUserId) {
      return <span className="chat-message-text">{t('chat.TYPING')}...</span>;
   }
   return null;
};

TypingStatus.propTypes = {
   typingStatusData: PropTypes.shape({
      groupId: PropTypes.string,
      fromUserId: PropTypes.string,
   }),
   t: PropTypes.func.isRequired,
};

const LastSeen = ({ activeChatJid = '' }) => {
   const { t } = useLanguage();
   const isGroup = isGroupChat(activeChatJid);
   const userId = getUserIdFromJid(activeChatJid);

   const typingStatusData = useTypingData(userId);
   const presenceData = usePresenceData(userId);
   const { isFeatureGated } = useConversationInviteInfo(activeChatJid);
   const { lastSeen } = useLastSeen(isGroup ? null : activeChatJid, presenceData?.status);

   if (isFeatureGated) return null;

   if (typingStatusData?.fromUserId || typingStatusData?.groupId) {
      return <TypingStatus typingStatusData={typingStatusData} t={t} />;
   }

   if (isGroup) {
      return <GroupParticipants activeChatJid={activeChatJid} />;
   }

   return <span className="chat-message-text">{lastSeen}</span>;
};

LastSeen.propTypes = {
   activeChatJid: PropTypes.string.isRequired,
};

export default LastSeen;
